import instance from './request'

import demo from './demo'

export default function() {
  return {
    ...demo(instance),
  }
}
